import {
  ISubscriptionCreatedResponse,
  ISubscriptionPayload,
  SubscriptionService,
} from '@/services/subscription'
import { ApiErrorResponse, ApiReactMutationOptions } from '@/types/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export function useCreateSubscription(
  options: ApiReactMutationOptions<
    ISubscriptionCreatedResponse,
    ISubscriptionPayload
  > = {}
) {
  const queryClient = useQueryClient()

  return useMutation<
    ISubscriptionCreatedResponse,
    ApiErrorResponse,
    ISubscriptionPayload
  >({
    ...options,
    mutationKey: [SubscriptionService.path],
    mutationFn: (payload: ISubscriptionPayload) => {
      return SubscriptionService.createSubscription(payload)
    },
    onSettled: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: [SubscriptionService.path],
        exact: false,
      })

      options?.onSettled?.(...args)
    },
  })
}
